/* @flow */

import React from 'react';
import { FormattedMessage } from 'react-intl';

import PencilIcon from '@uniiverse/library/assets/icons/pencil.svg';

import style from './edit-profile-button-module.css';

const EditProfileButton: Function = (): React$Element<*> => (
  <div className={style.container}>
    <a className={style.button} href="/dashboard/settings/profile">
      <PencilIcon className="Icon" />
      <FormattedMessage id="profile.edit" defaultMessage="Edit profile" />
    </a>
  </div>
);

export default EditProfileButton;



// WEBPACK FOOTER //
// ./src/components/profile/cover-photo/edit-profile-button.js